module.exports = __webpack_public_path__ + "compatibility-checker/img/thumbs-up.2dcf4484.svg";